import { render } from "./LastestNews.vue?vue&type=template&id=76848011"
import script from "./LastestNews.vue?vue&type=script&lang=js"
export * from "./LastestNews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__